function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from 'react';

var EyeVisible = function EyeVisible(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.197 19.222a1.645 1.645 0 000 1.558C8.35 26.612 14.175 31.667 20 31.667c5.825 0 11.65-5.055 14.803-10.889a1.645 1.645 0 000-1.558C31.65 13.388 25.825 8.333 20 8.333c-5.825 0-11.65 5.055-14.803 10.889v0z",
    stroke: "#A5AEA7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.535 23.535a5 5 0 10-7.068-7.068 5 5 0 007.066 7.066",
    stroke: "#A5AEA7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

export { EyeVisible };